import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../api-config';
import { handleAuthError } from './ValidateToken';
import { useNavigate } from 'react-router-dom';

const useFetchAudiolibro = (audiolibroId, usuarioId, token) => {
  const [audiolibro, setAudiolibro] = useState(null);
  const [capitulos, setCapitulos] = useState([]);
  const [currentChapterIndex, setCurrentChapterIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAudiolibro = async () => {
      setLoading(true);
      setError('');

      try {
        const response = await axios.get(`${API_URL}/audio-by-id/${audiolibroId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setAudiolibro(response.data.audiolibro);
        setCapitulos(
          response.data.capitulos.map((chapter, index) => ({
            indice: index + 1,
            nombre: `Pista ${index + 1}`,
          }))
        );

        const progressResponse = await axios.get(
          `${API_URL}/obtener-progreso/${usuarioId}/${audiolibroId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { chapter_index, progreso: savedProgress } = progressResponse.data;

        setCurrentChapterIndex(chapter_index || 1);
        setProgress(savedProgress || 0);
      } catch (err) {
        setError('Error al cargar el audiolibro. Por favor, intenta nuevamente.');
        handleAuthError(err, navigate);
      } finally {
        setLoading(false);
      }
    };

    fetchAudiolibro();
  }, [usuarioId, audiolibroId, token]);

  return {
    audiolibro,
    capitulos,
    currentChapterIndex,
    setCurrentChapterIndex,
    loading,
    error,
    progress,
    setProgress,
  };
};

export default useFetchAudiolibro;